<script setup>
import { DrawerOverlay as DrawerOverlayPrimitive } from "vaul-vue";
import { cn } from "@/shared/lib/utils";

const props = defineProps({
  class: { type: [String, Object, Array], default: undefined },
});
</script>

<template>
  <DrawerOverlayPrimitive
    data-slot="drawer-overlay"
    :class="
      cn(
        'data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 fixed inset-0 z-50 bg-black/5 backdrop-blur-sm',
        props.class
      )
    "
  />
</template>
